import { useEffect, useRef, useState } from 'react';
import * as React from 'react';
import { ShapesSvgDefaults } from 'utility/constants';
import { onDragEnd, onDragStart } from './dragAndDrop';
import { Shape } from './shapeData/types.shapes';
import { getSvgFromShape } from './shapeData/utility.shapes';
import { ShapeStrokeAndFill, modifySvg } from './shapesSvgTransformer';

interface Props {
    shape: Shape;
    strokeWidth?: number;
    fillColor?: string;
    stroke?: string;
    width: number;
    height: number;
    isDraggable: boolean;
    onDrag?: (shape: Shape) => void;
}

export function ShapeSvg({ shape, strokeWidth, fillColor, stroke, width, height, isDraggable, onDrag }: Props): JSX.Element {
    const [svg, setSvg] = useState<string>();
    const referenceImg = useRef<HTMLImageElement>(null);

    useEffect(() => {
        getSvgFromShape(
            shape,
            width,
            height,
            stroke || ShapesSvgDefaults.stroke,
            strokeWidth || ShapesSvgDefaults.strokeWidth,
            fillColor || ShapesSvgDefaults.fillColor,
        ).then((data) => setSvg(data.replace(/#/g, '%23')));
    }, [fillColor, height, shape, stroke, strokeWidth, width]);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onSVGDragStart = (event: any, svgString: string) => {
        onDrag && onDrag(shape);

        const attrs: ShapeStrokeAndFill = {
            'stroke-width': '2',
            fill: fillColor || ShapesSvgDefaults.fillColor,
            stroke: stroke || ShapesSvgDefaults.stroke,
        };
        const modifiedSvgString = modifySvg(svgString, attrs);
        const image = document.createElement('img');
        image.setAttribute('src', `data:image/svg+xml;utf8,${modifiedSvgString.replace(/#/g, '%23')}`);
        onDragStart(event, image);
    };

    return (
        <img
            ref={referenceImg}
            src={`data:image/svg+xml;utf8,${svg}`}
            alt=''
            draggable={isDraggable}
            onDragStart={isDraggable && svg ? (event) => onSVGDragStart(event, svg) : undefined}
            onDragEnd={isDraggable && svg ? onDragEnd : undefined}
        />
    );
}
